import * as yup from 'yup';

export const emailLinkSchema = yup.object().shape({
    EmailTo: yup.string()
        .required('Please select an email.')
        .nullable()
        .transform((curr, orig) => orig === '' ? null : curr)
});